<template>
  <div id="registrants">
    View My Registrants Details
  </div>
</template>

<script>
export default {
  name: 'registrants',
};
</script>

<style lang="scss"></style>
